// Polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { ColorThemePlugin } from '../services/vuestic-ui'
import store from '../store/index'
import router from '../router/index'
import { VuesticPlugin } from '../services/vuestic-ui/components'
import '../i18n/index'
import YmapPlugin from 'vue-yandex-maps'
import VueClipboard from 'vue-clipboard2'
import Axios from 'axios'

import '../metrics'
// import '../registerServiceWorker'

// import { consoleBuildInfo } from 'vue-cli-plugin-build-info/plugin'

// consoleBuildInfo()

Vue.use(VuesticPlugin)
Vue.use(YmapPlugin)
Vue.use(VueClipboard)

Vue.use(ColorThemePlugin, {
  primary: '#24264A',
  secondary: '#2E396F',
  success: '#8ddc88',
  info: '#71baff',
  danger: '#f8706d',
  warning: '#ffd652',
  gray: '#8396a5',
  dark: '#34495e',
})

Vue.mixin({
  methods: {
    parseDate (date) {
      const dt = new Date(date)

      const year = dt.getFullYear()
      let month = dt.getMonth() + 1
      let day = dt.getDate()
      let hour = dt.getHours()
      let minute = dt.getMinutes()

      month = (month < 10 ? '0' : '') + month
      day = (day < 10 ? '0' : '') + day
      hour = (hour < 10 ? '0' : '') + hour
      minute = (minute < 10 ? '0' : '') + minute

      return `${day}-${month}-${year} | ${hour}:${minute}`
    },
    getColorStatus (c) {
      switch (c) {
        case 'paid':
          return 'success'
        case 'warn':
          return 'warning'
        case 'disputed':
          return 'info'
        case 'pending':
          return 'gray'
        case 'failed':
          return 'danger'
        case 'refunded':
          return 'dark'
      }
    },
  },
})

router.beforeEach((to, from, next) => {
  const loggedIn = localStorage.getItem('user')

  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next('/auth')
    return
  }
  store.commit('setLoading', true)
  next()
})

router.afterEach((to, from) => {
  store.commit('setLoading', false)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  created () {
    const userString = localStorage.getItem('user')
    if (userString) {
      const userData = JSON.parse(userString)
      this.$store.commit('SET_USER_DATA', userData)
    }
    Axios.interceptors.response.use(
      response => response,
      error => {
        if (error.response.status === 401) {
          if (userString) {
            const userData = JSON.parse(userString)
            this.$store.dispatch('refreshLogin', userData)
          } else {
            this.$store.dispatch('logout')
          }
        }
        return Promise.reject(error)
      },
    )
  },
  render: h => h(App),
})
